import React from 'react';

/**
 * Seção com o plano de ação 5W2H
 * @param {object} planoAcao - Dados do plano de ação
 */
function NCResultActionPlan({ planoAcao }) {
  return (
    <section className="result-section">
      <h3><span className="material-symbols-outlined" style={{ fontSize: '18px', verticalAlign: 'middle', marginRight: '6px' }}>checklist</span>Plano de Ação 5W2H</h3>
      <div className="w5h2-grid">
        <div className="w5h2-item">
          <label>WHAT (O quê?)</label>
          <p>{planoAcao?.what || 'N/A'}</p>
        </div>
        <div className="w5h2-item">
          <label>WHY (Por quê?)</label>
          <p>{planoAcao?.why || 'N/A'}</p>
        </div>
        <div className="w5h2-item">
          <label>WHERE (Onde?)</label>
          <p>{planoAcao?.where || 'N/A'}</p>
        </div>
        <div className="w5h2-item">
          <label>WHEN (Quando?)</label>
          <p>{planoAcao?.when || 'N/A'}</p>
        </div>
        <div className="w5h2-item">
          <label>WHO (Quem?)</label>
          <p>{planoAcao?.who || 'N/A'}</p>
        </div>
        <div className="w5h2-item">
          <label>HOW (Como?)</label>
          <p>{planoAcao?.how || 'N/A'}</p>
        </div>
        <div className="w5h2-item">
          <label>HOW MUCH (Quanto?)</label>
          <p>{planoAcao?.how_much || 'N/A'}</p>
        </div>
      </div>
    </section>
  );
}

export default NCResultActionPlan;